import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MortgageApplicationNavigationEvents } from '../../constants/mortgage-application-navigation-events';
import { TabNavigationService } from './../../../form-application/mortgage-application/services/tab-navigation.service';
import { ProductPickerNavigationService } from './../../../product-picker-controls/services/product-picker-navigation.service';
import { ReferenceDataCaseStatus } from './../../constants/reference-data-case-status';
import { ReferenceDataLabels } from './../../constants/reference-data-labels';
import { ReferenceDataOptionLists } from './../../constants/reference-data-option-lists';
import { UserPermissions } from './../../constants/user-permissions';
import { ApplicationCase } from './../../models/api/application-case.model';

@Component({
  selector: 'boi-case-summary-header',
  templateUrl: './case-summary-header.component.html',
  styleUrls: ['./case-summary-header.component.scss']
})
export class CaseSummaryHeaderComponent implements OnDestroy {
  @Input() public model: ApplicationCase;
  @Input() public headerTextName: string;
  @Input() public logoPath: string;
  @Input() public isCallInProgress: boolean;
  @Input() public isCallAssociated: boolean;
  @Input() public displayAdviceTabLink = false;
  @Input() public displayAddApplicantLink = false;
  @Output() public readonly setAssociatedCaseToCall = new EventEmitter<number>();

  private readonly destroySubject$ = new Subject();
  public adviceNotesDialogOpened = false;
  public isProductPicker: boolean;
  public referenceDataLabels = ReferenceDataLabels;
  public referenceDataCaseStatus = ReferenceDataCaseStatus;
  public referenceDataOptionLists = ReferenceDataOptionLists;
  public userPermissions = UserPermissions;

  public statusWithGreenBulletRequiredInHeader: Array<string> = [
    this.referenceDataCaseStatus.AipAccepted,
    this.referenceDataCaseStatus.AppAccepted,
    this.referenceDataCaseStatus.RecommendationMade,
    this.referenceDataCaseStatus.KfiIssued,
    this.referenceDataCaseStatus.AppAcceptedPendingPayment,
    this.referenceDataCaseStatus.AppSubmitted,
    this.referenceDataCaseStatus.AppReceived,
    this.referenceDataCaseStatus.SamAwaitingAssessment,
    this.referenceDataCaseStatus.SamValucomp,
    this.referenceDataCaseStatus.ReadyForReview,
    this.referenceDataCaseStatus.SamDayOneDate,
    this.referenceDataCaseStatus.SamRot,
    this.referenceDataCaseStatus.SamFundsReleased,
    this.referenceDataCaseStatus.SamCompleted
  ];

  constructor(
    protected readonly router: Router,
    protected readonly tabNavigationService: TabNavigationService,
    public productPickerNavigationService: ProductPickerNavigationService
  ) {
    this.productPickerNavigationService.isProductPicker$
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((isProductPicker) => {
        this.isProductPicker = isProductPicker;
      });
  }

  public goToCaseHub(): void {
    void this.router.navigate(['/caseHub']);
  }

  public addApplicant(): void {
    this.tabNavigationService.emitEvent({
      type: MortgageApplicationNavigationEvents.AddApplicant
    });
  }

  public isGreenBulletDisplayRequired(status: string): boolean {
    return this.statusWithGreenBulletRequiredInHeader.indexOf(status) !== -1;
  }

  public ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }
}
